import { environment } from "@env/environment";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { NgxHateoasClientConfigurationService } from "@lagoshny/ngx-hateoas-client";
import { TicketCompletionCode } from "@app/models/rest/ticket-completion-code";
import { Ticket } from "@app/models/rest/ticket";
import { Visit } from "@app/models/rest/visit";

/**
 * Factory function to create an initializer that configures the application
 * during bootstrap
 */
export function initializerFactory(
  clientConfigService: ClientConfigService,
  hateoasConfigService: NgxHateoasClientConfigurationService
): any {
  return () =>
    new Promise<any>((resolve) => {
      clientConfigService.init().then((value) => {
        hateoasConfigService.configure({
          http: {
            rootUrl: value.serviceUrl
          },
          isProduction: environment.production,
          cache: { enabled: false },
          // logs: {verboseLogs: true},
          pagination: { defaultPage: { page: 0, size: 5000 } },
          useTypes: {
            resources: [TicketCompletionCode, Ticket, Visit]
          },
          logs: {
            verboseLogs: false
          },
          typesFormat: {
            date: {
              patterns: [
                "yyyy-MM-dd'T'HH:mm:ssXXX",
                "yyyy-MM-dd'T'HH:mm:ss.SXXX",
                "yyyy-MM-dd'T'HH:mm:ss.SSXXX",
                "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
                "yyyy-MM-dd'T'HH:mm:ss.SSSSXXX",
                "yyyy-MM-dd'T'HH:mm:ss.SSSSSXXX",
                "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
                "yyyy-MM-dd'T'HH:mm:ss.SSSSSSSXXX"
              ]
            }
          }
        });
        resolve(true);
      });
    });
}
